// src/belediye/pages/dashboard/uiProfiles.js
//
// FAZ-17 — Sunum profili (ui_profile) + dashboard kart havuzu.
//
// Bu dosya YALNIZ sunum/görünüm mantığıdır — yetki motoru bunu ASLA okumaz
// (backend common_app/authz/ içinde ui_profile'a dair tek satır yoktur).
// Altın kural (03-ekran 15.3): varyant yeni yetenek AÇAMAZ; yalnız izin-korumalı
// havuzdan seçim/dizilim yapar. Her kart izin-etiketlidir ve render öncesi
// canAll(permissions) süzgecinden geçer.
//
// Sıfır-sürpriz: bilinmeyen/null profil → operasyonel = bugünkü dashboard birebir.
// Yönetici (başkan) varyantının nihai kompozisyonunu kullanıcı sonradan
// tasarlayacak; buradaki liste işlevsel ayrımı kuran PLACEHOLDER'dır.

// ── Kart havuzu: dashboard_app beslemeli tüm kartlar dashboard.view ister. ──
export const DASHBOARD_CARDS = {
  kpi_ozet: { permissions: ["dashboard.view"] }, // 7'li KPI şeridi
  harita: { permissions: ["dashboard.view"] }, // Başvuru haritası
  durum_dagilimi: { permissions: ["dashboard.view"] }, // Durum dağılımı grafiği
  acik_kapali: { permissions: ["dashboard.view"] }, // Açık/Kapalı donut
  acik_sure: { permissions: ["dashboard.view"] }, // Açık başvuru süreleri
  kirilim: { permissions: ["dashboard.view"] }, // Mahalle/Birim kırılımı
  kuyruk: { permissions: ["dashboard.view"] }, // Son yeni / cevapsız kuyruğu
  // FAZ-76 — GÖREV KARTLARI KALDIRILDI (kullanıcı 2026-07-30: "dashboard'da
  // görevlerle ilgili bir şey görmek istemiyorum"). Anahtarlar havuzdan da
  // silindi: sözlükte kalan ölü bir anahtar, ileride bir profile sessizce geri
  // sızabilir. Görevin yeri Görev Ata / Görevlerim sayfalarıdır.
  // (Havuz mekanizmasının "dashboard dışı izin etiketi" yeteneği DURUYOR —
  // yalnız bu iki kullanıcısı kalktı.)
};

// Operasyonel = bugünkü kart sırası birebir (varsayılan; hiçbir davranış değişmez).
const OPERASYONEL_CARDS = [
  "kpi_ozet",
  "harita",
  "durum_dagilimi",
  "acik_kapali",
  "acik_sure",
  "kirilim",
  "kuyruk",
];

// Yönetici — stratejik vurgu + iş kuyruğu. 2026-07-10 (kullanıcı kararı): son
// başvurular + en çok bekleyenler ("kuyruk") dashboard'da GÖRÜNSÜN. Bu yüzden
// yonetici artık tam havuzu alır (operasyonel ile aynı kart kümesi). İleride
// yonetici'ye özel dizilim istenirse buradan yeniden tanımlanabilir.
const YONETICI_CARDS = [
  "kpi_ozet",
  "harita",
  "durum_dagilimi",
  "acik_kapali",
  "acik_sure",
  "kirilim",
  "kuyruk",
];

// FAZ-20 — 4 profil. halk_masasi/saha DASHBOARD'a inmez (kendi ekranları var →
// dashboard kart havuzu boş); landing kendi deneyimlerine yönlendirir.
// saha landing "saha" = birim-göreli suffix (resolveLanding birimli(...) çözer);
// canonical /yonetim/saha/gorevlerim FAZ-22'de. yonetici/operasyonel dashboard'a iner.
export const UI_PROFILES = {
  operasyonel: { cards: OPERASYONEL_CARDS, landing: null },
  yonetici: { cards: YONETICI_CARDS, landing: null },
  halk_masasi: { cards: [], landing: "/yonetim/halk-masasi" },
  saha: { cards: [], landing: "saha" },
};

export const DEFAULT_UI_PROFILE = "operasyonel";

// Profil çözümü: bilinmeyen/null/undefined → güvenli varsayılan (operasyonel).
export function resolveUiProfile(uiProfileKey) {
  return UI_PROFILES[uiProfileKey] || UI_PROFILES[DEFAULT_UI_PROFILE];
}

// Görünür kart listesi: profil kart sırasından yalnız canAll(permissions) geçenler.
// canAll fonksiyon değilse (uiOn=false eski yol) izin süzgeci UYGULANMAZ —
// profil kartları birebir döner; böylece bugünkü DOM korunur.
export function visibleDashboardCards(uiProfileKey, canAll) {
  const profile = resolveUiProfile(uiProfileKey);
  const list = Array.isArray(profile.cards) ? profile.cards : [];
  if (typeof canAll !== "function") {
    return list.slice();
  }
  return list.filter((key) => {
    const meta = DASHBOARD_CARDS[key];
    if (!meta) return false;
    return canAll(meta.permissions || []);
  });
}
